import { render, staticRenderFns } from "./ActiveLicense.vue?vue&type=template&id=56bd3f3c&scoped=true&"
import script from "./ActiveLicense.vue?vue&type=script&lang=js&"
export * from "./ActiveLicense.vue?vue&type=script&lang=js&"
import style0 from "./ActiveLicense.vue?vue&type=style&index=0&id=56bd3f3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd3f3c",
  null
  
)

export default component.exports